import { useState, useCallback, useEffect } from 'react';

const storageKey = (publicKey) => `publicPageAccessToken__${publicKey}`;

const read = (publicKey) => {
  if(publicKey == null) return null;

  try {
    return window.sessionStorage.getItem(storageKey(publicKey));
  } catch(e) {
    return null;
  }
};

export default function usePublicPageAccessToken (publicKey) {
  const [accessToken, setAccessToken] = useState(() => read(publicKey));

  useEffect(() => {
    setAccessToken(read(publicKey));
  }, [publicKey]);

  const saveAccessToken = useCallback((newAccessToken) => {
    try {
      window.sessionStorage.setItem(storageKey(publicKey), newAccessToken);
    } catch(e) {}
    setAccessToken(newAccessToken);
  }, [publicKey]);

  return { accessToken, saveAccessToken, };
};
